import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionVideo from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* videoDetail(action) {
  try {
    const response = yield call(() => API.get(ROUTES.API_VIDEO_DETAIL +'/'+action.payload.id));
    yield put(actionVideo.getVideoDetailSuccess(response));
  } catch (error) {
    yield put(actionVideo.getVideoDetailFailed({}));
  }
}

function* videoTemplate({params}) {
  try {
    const response = yield call(() => API.get(ROUTES.API_VIDEO_DETAIL_TEMPLATE, {params}));
    yield put(actionVideo.getVideoContentTemplateSuccess({
      data: response,
      type: actionTypes.GET_VIDEO_CONTENT_TEMPLATE_SUCCESS
    }));
  } catch (error) {
    yield put(actionVideo.getVideoContentTemplateFailed(error))
  }
}

function* updateVideo({params}) {
  try {
    const response = yield call(() => API.post(ROUTES.API_VIDEO_UPDATE+'/'+params.id, params));
    console.log(response, 'response update video');
    if (response.data?.data) {
      yield put(actionVideo.getVideoDetailSuccess(response.data));
      yield put(actionVideo.updateVideoSuccess(response.data));
    }
    
  } catch (error) {
    yield put(actionVideo.updateVideoFailed(error));
  }
}

function* videoEmoji({params}) {
  try {
    const response = yield call(() => API.get(ROUTES.API_VIDEO_EMOJI, {params}));
    yield put(actionVideo.getVideoEmojiSuccess(response));
  } catch (error) {
    yield put(actionVideo.getVideoEmojiFailed(error));
  }
}

function* deleteVideo(action) {
  try {
    const response = yield call(() => API.post(ROUTES.API_VIDEO_DELETE+'/'+action.payload.id));
    yield put(actionVideo.deleteVideoSuccess(response.data));
  } catch (error) {
    yield put(actionVideo.deleteVideoFailed(error));
  }
}

function* updateExplainPopup(action){
  try {
    const response = yield call(() => API.post(ROUTES.API_UPDATE_AUTH_ME, action.payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }));
    yield put(actionVideo.updateExplainVideoPopupSuccess(response.data));
  } catch (error) {

  }
}

function* updateVideoMergeError(action){
  console.log(72, action);
  try {
    const response = yield call(() => API.post(ROUTES.API_UPDATE_AUTH_ME, action.payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }));
    yield put(actionVideo.updateVideoMergeErrorSuccess(response.data));
  } catch (error) {

  }
}

function* retrictedKeyword({params}) {
  try {
    const response = yield call(() => API.get(ROUTES.API_RESTRICTED_KEYWORD, {params}));
    yield put(actionVideo.getRestrictedKeywordSuccess({
      data: response.data,
      type: actionTypes.GET_RESTRICTED_KEYWORD_SUCCESS
    }));
  } catch (error) {
    yield put(actionVideo.getRestrictedKeywordFailed(error))
  }
}

function* getTimeRenderVideo({params}) {
  try {
    const response = yield call(() => API.get(ROUTES.API_VIDEO_RENDERING_STATUS, {params}));
    yield put(actionVideo.getTimeVideoRenderSuccess({
      data: response.data?.data,
      type: actionTypes.GET_TIME_VIDEO_RENDER_SUCCESS
    }));
  } catch (error) {
    yield put(actionVideo.getTimeVideoRenderFaild({
      data: [],
      type: actionTypes.GET_TIME_VIDEO_RENDER_FAILED
    }));
  }
}


function* videoSaga() {
  yield takeLatest(actionTypes.GET_VIDEO_DETAIL_REQUEST, videoDetail);
  yield takeLatest(actionTypes.GET_VIDEO_CONTENT_TEMPLATE_REQUEST, videoTemplate);
  yield takeLatest(actionTypes.UPDATE_VIDEO_REQUEST, updateVideo);
  yield takeLatest(actionTypes.GET_VIDEO_EMOJI_REQUEST, videoEmoji);
  yield takeLatest(actionTypes.DELETE_VIDEO_REQUEST, deleteVideo);
  yield takeLatest(actionTypes.UPDATE_EXPLAIN_VIDEO_POPUP_REQUEST, updateExplainPopup);
  yield takeLatest(actionTypes.GET_RESTRICTED_KEYWORD_REQUEST, retrictedKeyword);
  yield takeLatest(actionTypes.GET_TIME_VIDEO_RENDER_REQUEST, getTimeRenderVideo);
  yield takeLatest(actionTypes.UPDATE_VIDEO_MERGE_ERROR_REQUEST, updateVideoMergeError);
}

export default videoSaga;
